import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { DbExercisesService } from 'src/services/db-exercises.service';

@Component({
    selector: 'app-db-exercise-img',
    template: ` <canvas #canvas></canvas> `,
    styles: [
        `
      canvas {
        width: 100%;
        height: auto;
      }
    `,
    ],
    standalone: false
})
export class DbExerciseImgComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('canvas', { static: true })
  canvasRef!: ElementRef<HTMLCanvasElement>;
  @Input() img1: string = '';
  @Input() img2: string = '';

  private ctx!: CanvasRenderingContext2D;
  private image1: HTMLImageElement = new Image();
  private image2: HTMLImageElement = new Image();
  private showFirstImage: boolean = true;
  private interval: any;
  private imagesLoaded: boolean = false;

  constructor(private dbExercisesService: DbExercisesService) {}

  async ngOnInit() {
    await this.loadImages();
    this.imagesLoaded = true;
    this.drawImage();
  }

  ngAfterViewInit() {
    this.ctx = this.canvasRef.nativeElement.getContext('2d')!;
    this.startImageToggle();
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private async loadImages() {
    try {
      const url1 = await this.dbExercisesService.getImageUrl(this.img1);
      const url2 = await this.dbExercisesService.getImageUrl(this.img2);

      await Promise.all([
        this.loadImage(this.image1, url1),
        this.loadImage(this.image2, url2),
      ]);
    } catch (error) {
      console.error('Error loading images:', error);
      // Handle error (e.g., display a default image)
    }
  }

  private loadImage(img: HTMLImageElement, src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      img.onload = () => resolve();
      img.onerror = reject;
      img.src = src;
    });
  }

  private startImageToggle() {
    this.interval = setInterval(() => {
      if (this.imagesLoaded) {
        this.showFirstImage = !this.showFirstImage;
        this.drawImage();
      }
    }, 1000);
  }

  private drawImage() {
    if (!this.ctx || !this.imagesLoaded) return;

    const canvas = this.canvasRef.nativeElement;
    const img = this.showFirstImage ? this.image1 : this.image2;

    canvas.width = img.width;
    canvas.height = img.height;
    this.ctx.clearRect(0, 0, canvas.width, canvas.height);
    this.ctx.drawImage(img, 0, 0);
  }
}
